import { createContext, useState } from "react";
import { useGetUserAvailabelBalance } from "../lib/queries/queriesAndMutations";
const inititialState = {
  transferMode: "external",
  balance: "",
  isPending: true,
};

export const WithdrawContext = createContext(inititialState);
 const WithdrawProvider = ({ children }) => {
  const { data: balance, isPending } = useGetUserAvailabelBalance();

  const [transferType, setTransferType] = useState("external");

  const value = {
    transferType: transferType,
    setTransferType,
    balance,
    isPending,
  };


  return (
    <WithdrawContext.Provider value={value}>
      {children}
    </WithdrawContext.Provider>
  );
};

export default WithdrawProvider ;
